var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminOutlinedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 19.1668C5.36949 18.1377 1.66699 13.7685 1.66699 9.16683V4.16683L10.0003 0.833496L18.3337 4.16683V9.16683C18.3337 13.7702 14.6312 18.1377 10.0003 19.1668ZM3.33366 5.00016V9.16683C3.38128 11.0936 4.05896 12.9517 5.26297 14.4567C6.46699 15.9617 8.131 17.0308 10.0003 17.5002C11.8697 17.0308 13.5337 15.9617 14.7377 14.4567C15.9417 12.9517 16.6194 11.0936 16.667 9.16683V5.00016L10.0003 2.50016L3.33366 5.00016Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 9.16667C11.1509 9.16667 12.0837 8.23393 12.0837 7.08333C12.0837 5.93274 11.1509 5 10.0003 5C8.84973 5 7.91699 5.93274 7.91699 7.08333C7.91699 8.23393 8.84973 9.16667 10.0003 9.16667Z",
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83301 12.5C6.24375 13.2485 6.846 13.8744 7.57812 14.3137C8.31025 14.753 9.14594 14.9898 9.99967 15C10.8534 14.9898 11.6891 14.753 12.4212 14.3137C13.1533 13.8744 13.7556 13.2485 14.1663 12.5C14.1455 10.92 11.3813 10 9.99967 10C8.61051 10 5.85384 10.92 5.83301 12.5Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminOutlinedIcon);
export default __webpack_public_path__ + "static/media/admin-outlined-icon.bbc23444742295abcb40934dff94cd10.svg";
export { ForwardRef as ReactComponent };